import React from 'react';
import './style.css';

const ProgressBar = ({ value, numberPage }) => {
  return (
    <div className="progress-bar-container">
      <div
        className="progress-bar-loading"
        style={{ background: ` linear-gradient(to right, #fdcb00 ${(value * 100) / numberPage}%, #e4141400 0%) ` }}
      >
        {value}/{numberPage}
      </div>
      &nbsp;
    </div>
  );
};

export default ProgressBar;
